import React from 'react';
import cnames from 'classnames';

// Section components
import Trustpilot from '../Trustpilot/AsyncTrustpilot';
import PropertyTypes from '../PropertyTypes';
import Trending from '../Trending';
import TrendingCorridorDestinations from '../TrendingCorridorDestinations';
import Lyp from '../Lyp';
import ValueProps from '../ValueProps';
import SeoLinkpile from '../SeoLinkpile';
import RecentTravelerActivity from '../RecentTravelerActivity';
import ReasonsToBelieve from '../ReasonsToBelieve';
import { Experiment } from '../Experiment';
import ErrorBoundary from '../ErrorBoundary';
import RecommendedProperties from '../RecommendedProperties';
import RecommendedDestinations from '../RecommendedDestinations';

import './Content.less';

const CNAME = 'Content';

const Content = ({ showTrustPilot, isDesktop }) => (
  <Experiment name={'HA_PTA_LANDING_HighConvertingModulesAboveTheFold'} earlyReport>
    {aboveTheFoldValue => (
      <main role="main" className={cnames({ [`${CNAME}__main--variant1`]: aboveTheFoldValue === 1 && isDesktop })}>
        <article className={CNAME}>
          {aboveTheFoldValue !== 1 &&
            <Experiment name={'HA_PTA_LANDING_ReasonsToBelieve'} earlyReport>
              {
                reasonsToBelieveValue => reasonsToBelieveValue === 1
                  ? <ReasonsToBelieve />
                  : <ValueProps />
              }
            </Experiment>
          }
          <RecentTravelerActivity />
          <Experiment name={'HA_PTA_LANDING_RecommendedPropertiesHP'}>
            { recommendedPropertiesValue => recommendedPropertiesValue === 1 && <RecommendedProperties /> }
          </Experiment>
          <RecommendedDestinations />
          <Experiment name="HA_PTA_LANDING_PropertyTypeImagesIteration2" report>
            <ErrorBoundary>
              <PropertyTypes />
            </ErrorBoundary>
          </Experiment>
          <Experiment name={'HA_PTA_LANDING_TrendingDestinationsSeRPLink'} earlyReport>
            <Experiment name="HA_PTA_LANDING_CorridorTrendingDestinationsV2HP" earlyReport>
              {value => value === 1
                ? <TrendingCorridorDestinations />
                : <Trending />
              }
            </Experiment>
          </Experiment>
          {aboveTheFoldValue === 1 &&
            <Experiment name={'HA_PTA_LANDING_ReasonsToBelieve'} earlyReport>
              {
                reasonsToBelieveValue => reasonsToBelieveValue === 1
                  ? <ReasonsToBelieve />
                  : <ValueProps />
              }
            </Experiment>
          }
          {showTrustPilot && <Trustpilot />}
          <Lyp />
          <SeoLinkpile/>
        </article>
      </main>
    )}
  </Experiment>
);

export default Content;
